import { useEffect, useState } from 'react';
import api from '../services/api';

// Valores de respaldo: los precios de lanzamiento (estudio de mercado 2026-09-29).
// Se usan si /api/planes falla o todavía no trae los campos nuevos.
export const PLANES_DEFAULT = {
  free: { transacciones: 150, cfdi: 10, cuentas: 3, tarjetas: 2, presupuestos: 5, metas: 3 },
  pro: {
    mensual: 59, anual: 590,           // precio fundador
    listaMensual: 79, listaAnual: 690, // precio de lista
    lugares: null,                     // null = no se conoce, no se muestra
    transacciones: null,
  },
  trialDias: 14,
};

const num = (...vals) => {
  for (const v of vals) {
    if (v === null || v === undefined || v === '') continue;
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return null;
};

// Acepta varios nombres de campo porque el backend está cambiando en paralelo.
export function normalizarPlanes(data) {
  const out = JSON.parse(JSON.stringify(PLANES_DEFAULT));
  const lista = Array.isArray(data) ? data : [];
  const free = lista.find(p => p.nombre === 'free');
  const pro = lista.find(p => p.nombre === 'pro');
  if (free) {
    out.free.transacciones = num(free.max_transacciones) ?? out.free.transacciones;
    out.free.cfdi = num(free.max_cfdi_mes, free.max_cfdi, free.cfdi_mes_gratis) ?? out.free.cfdi;
    out.free.cuentas = num(free.max_cuentas) ?? out.free.cuentas;
    out.free.tarjetas = num(free.max_tarjetas) ?? out.free.tarjetas;
    out.free.presupuestos = num(free.max_presupuestos) ?? out.free.presupuestos;
    out.free.metas = num(free.max_metas) ?? out.free.metas;
  }
  if (pro) {
    // Contrato de GET /api/planes (PlanesController): precio_mensual/anual = lista;
    // precio_efectivo_* = lo que paga hoy el visitante (fundador mientras haya cupo)
    const lm = num(pro.precio_mensual);
    const la = num(pro.precio_anual);
    if (lm) out.pro.listaMensual = lm;
    if (la) out.pro.listaAnual = la;
    const mensual = num(pro.precio_efectivo_mensual, pro.precio_fundador_mensual);
    const anual = num(pro.precio_efectivo_anual, pro.precio_fundador_anual);
    if (mensual) out.pro.mensual = mensual;
    if (anual) out.pro.anual = anual;
    out.pro.lugares = num(pro.cupos_fundador_restantes);
    out.pro.transacciones = num(pro.max_transacciones);
    out.trialDias = num(pro.trial_dias, pro.dias_prueba) ?? out.trialDias;
  }
  return out;
}

export function usePlanesPublicos() {
  const [planes, setPlanes] = useState(PLANES_DEFAULT);
  useEffect(() => {
    let vivo = true;
    api.get('/planes', { skipAuthRedirect: true })
      .then(r => { if (vivo) setPlanes(normalizarPlanes(r.data)); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  return planes;
}
